<template>
  <!-- 検査案件一覧 -->
  <div id="RequestSearch">
    <div id="container">
      <div class="labelTitle lable">検査案件検索</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input type="text" v-model="searchConditions.receiptNumber"/></td>
            <th>種別</th>
            <td>
              <select v-model="searchConditions.kind">
                <option value="[]"></option>
                <option v-for="item in kindGroupMaster" :key="item.value" :value="item.value">{{item.label}}</option>
              </select>
            </td>
            <th>機種</th>
            <td>
              <select v-model="searchConditions.instrumentKind">
                <option value=""></option>
                <option
                  v-for="instrument in filteredInstrumentKindOptions"
                  :key="instrument.value"
                  :value="instrument.value"
                >
                  {{ instrument.label }}
                </option>
              </select>
            </td>
            <th>デモ</th>
            <td>
              <select v-model="searchConditions.demoFlag">
                <option :value="0"></option>
                <option :value="1">含まない</option>
                <option :value="2">デモのみ</option>
              </select></td>
          </tr>
          <tr>
            <th>状態</th>
            <td>
              <select v-model="searchConditions.status">
                <option value= "[]"></option>
                <option v-for="item in statusList" :key="item.code" :value="item.code">{{item.name}}</option>
              </select>
            </td>
            <th>進捗状況</th>
            <td>
              <select v-model="searchConditions.progress">
                <option value="[]"></option>
                <option v-for="item in progressList" :key="item.code" :value="item.code">{{item.name}}</option>
              </select>
            </td>
            <th>報告書DL<br>(外部)</th>
            <td><select id="requestDLFlag" v-model="searchConditions.requestDLFlag"><option value=""></option><option value="0">未</option><option value="1">済</option></select></td>
            <th>報告書DL<br>(内部)</th>
            <td><select id="staffDLFlag" v-model="searchConditions.staffDLFlag"><option value=""></option><option value="0">未</option><option value="1">済</option></select></td>
          </tr>
          <tr>
            <th>依頼元</th>
            <td><input type="text" v-model="searchConditions.client"/></td>
            <th>医療機関<br>/企業</th>
            <td><input type="text" v-model="searchConditions.hospital"/></td>
            <th>患者名</th>
            <td><input type="text" v-model="searchConditions.patientName"/></td>
            <th>クイック<br>オーダー</th>
            <td>
              <select v-model="searchConditions.quickOrderFlag">
                <option value=""></option>
                <option value="0">未</option>
                <option value="1">済み</option>
              </select></td>
          </tr>
          <tr>
            <th>ブロック</th>
            <td>
              <select v-model="searchConditions.block">
                <option value=""></option>
                <option v-for="item in blockMaster" :key="item.code" :value="item.code">{{item.name}}</option>
              </select>
            </td>
            <th>担当支店</th>
            <td>
              <select v-model="searchConditions.branchOfficeCode">
                <option value=""></option>
                <option v-for="item in branchOfficeMaster" :key="item.code" :value="item.code">{{item.name}}</option>
              </select>
           </td>
            <th>営業所<br>（売上）</th>
            <td>
              <select v-model="searchConditions.salesOfficeCode">
                <option value=""></option>
                <option v-for="item in salesOfficeMaster" :key="item.code" :value="item.code">{{item.name}}</option>
              </select>
           </td>
            <th>営業担当者</th>
            <td><input type="text" v-model="searchConditions.salesStaffName"/></td>
          </tr>
          <tr>
            <th>依頼日</th>
            <td colspan="3">
                  <input type="date" v-model="searchConditions.applicationDateStart"/>
               ～ <input type="date" v-model="searchConditions.applicationDateEnd"/>
            </td>
            <th>完了日</th>
            <td colspan="3">
                  <input type="date" v-model="searchConditions.completionDateStart"/>
               ～ <input type="date" v-model="searchConditions.completionDateEnd"/></td>
          </tr>
          <tr>
            <th>院内貸出<br>の有無</th>
            <td>
              <select v-model="searchConditions.depositMachineFlag">
                <option :value="0"></option>
                <option :value="1">有</option>
                <option :value="2">無</option>
              </select>
            </td>
            <th>HST同梱<br>の有無</th>
            <td>
              <select v-model="searchConditions.hstRequestFlag">
                <option :value="0"></option>
                <option :value="1">有</option>
                <option :value="2">無</option>
              </select>
            </td>
            <th>いびき<br>センサー</th>
            <td>
              <select v-model="searchConditions.snoreSensor">
                <option></option>
                <option :value="1">無</option>
                <option :value="2">有</option>
              </select>
            </td>
            <th>判定有無</th>
            <td><select id="judgementFlag" v-model="searchConditions.judgementFlag"><option value=""></option><option value="0">無</option><option value="1">有</option></select></td>

          </tr>
          <tr>
            <th>AHI</th>
            <td colspan="3">
              <input
                type="number"
                step="0.1"
                v-model="searchConditions.ahiFrom"
                style="width: 200px;"
              />
              ～
              <input
                type="number"
                step="0.1"
                v-model="searchConditions.ahiTo"
                style="width: 200px;"
              />
            </td>
            <th>CVHRI</th>
            <td colspan="3">
              <input
                type="number"
                step="0.1"
                v-model="searchConditions.cvhriFrom"
                style="width: 100px;"
              />
              ～
              <input
                type="number"
                step="0.1"
                v-model="searchConditions.cvhriTo"
                style="width: 100px;"
              />
              <select v-model="searchConditions.cvhriFlag" style="width: 150px; margin-left: 70px;">
                <option></option>
                <option :value="1">算出不可</option>
              </select>
            </td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area" v-if="data.length > 0">
        <div style="float:left">
          <b-button style="margin-right:10px;" class="clipboadCopyButton is-primary" @click="clipboardCopy('requestSearchTable')">クリップボードにコピー</b-button>
          <b-button v-if="!isOpen" @click="isOpen=true" class="is-primary" icon-left="table-column-width" >列選択</b-button>
          <b-button v-if="isOpen" @click="isOpen=false" class="is-primary" icon-left="close-box-outline" >閉じる</b-button>
          <div v-if="isOpen" style="clear:both; height:0px;" >
            <div class="box selectColumn">
              <div style="height:30px;">
                <b-checkbox class="columnCheckBox" v-model="isAllChecked" @input="changeAllCheckBox" >全てチェック</b-checkbox>
                <a style="float:right;" @click="isOpen=false"><b-icon icon="close"/></a>
              </div>
              <b-checkbox class="columnCheckBox" v-model="columns.receiptNumber.checked" @input="changeCheckBox(columns.receiptNumber)" >受付番号</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.applicationDate.checked" @input="changeCheckBox(columns.applicationDate)" >依頼日</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.kind.checked" @input="changeCheckBox(columns.kind)" >種別</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.instrumentKind.checked" @input="changeCheckBox(columns.instrumentKind)" >機種</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.client.checked" @input="changeCheckBox(columns.client)" >依頼元</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.hospital.checked" @input="changeCheckBox(columns.hospital)" >医療機関/企業</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.patient.checked" @input="changeCheckBox(columns.patient)" >患者名</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.officeCode.checked" @input="changeCheckBox(columns.officeCode)" >営業所コード</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.officeName.checked" @input="changeCheckBox(columns.officeName)" >営業所（売上）</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.salesStaff.checked" @input="changeCheckBox(columns.salesStaff)" >営業担当者名</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.ahi.checked" @input="changeCheckBox(columns.ahi)" >AHI</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.cvhri.checked" @input="changeCheckBox(columns.cvhri)" >CVHRI(最大値)</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.quickOrder.checked" @input="changeCheckBox(columns.quickOrder)" >クイックオーダー</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.status.checked" @input="changeCheckBox(columns.status)" >状態</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.progress.checked" @input="changeCheckBox(columns.progress)" >進捗状況</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.completionDate.checked" @input="changeCheckBox(columns.completionDate)" >完了日</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.hstRequestFlag.checked" @input="changeCheckBox(columns.hstRequestFlag)" >HST同梱の有無</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.snoreSensor.checked" @input="changeCheckBox(columns.snoreSensor)" >いびきセンサー</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.requestDLFlag.checked" @input="changeCheckBox(columns.requestDLFlag)" >報告書DL(外部)</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.staffDLFlag.checked" @input="changeCheckBox(columns.staffDLFlag)" >報告書DL(内部)</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.inquiry.checked" @input="changeCheckBox(columns.inquiry)" >問い合わせ</b-checkbox>
            </div>
          </div>
        </div>
        <span class="result-count" style="position: relative; top:6px;">件数：{{data.length}}件</span>
        <b-table
          id="requestSearchTable"
          :data="data"
          :paginated="true"
          per-page="100"
          pagination-position="both"
          default-sort="receiptNumber"
          default-sort-direction="desc"
        >
          <template slot-scope="props">
            <b-table-column :visible="columns.receiptNumber.checked" field="receiptNumber" label="受付番号" :width="columns.receiptNumber.width" centered sortable>
                <router-link v-if="props.row.type=='kenshin'" :to="{name:'RequesKenshintDetail', params:{item:props.row, searchConditions:searchConditions}}">{{props.row.receiptNumber}}</router-link>
                <router-link v-else :to="{name:'RequestDetail', params:{item:props.row, searchConditions:searchConditions}}">{{props.row.receiptNumber}}</router-link>
            </b-table-column>
            <b-table-column :visible="columns.applicationDate.checked"  field="applicationDate" label="依頼日" :width="columns.applicationDate.width" centered sortable>{{props.row.applicationDate }}</b-table-column>
            <b-table-column :visible="columns.kind.checked"  field="kind" label="種別" :width="columns.kind.width" sortable>{{getKindGroupLabel(props.row.kind)}}<span v-if="props.row.demo" class="demo"/><span v-if="props.row.depo" class="depo"/></b-table-column>
            <b-table-column :visible="columns.instrumentKind.checked" field="instrumentKind" label="機種" :width="columns.instrumentKind.width" sortable >{{props.row.kindLabel}}</b-table-column>
            <b-table-column :visible="columns.client.checked"  field="client" label="依頼元" :width="columns.client.width" sortable>{{props.row.client}}<span v-if="props.row.proxyFlag" class="agent"/></b-table-column>
            <b-table-column :visible="columns.hospital.checked"  field="hospital" label="医療機関/企業" :width="columns.hospital.width" sortable>{{props.row.hospital}}</b-table-column>
            <b-table-column :visible="columns.patient.checked"  field="patientName" label="患者名" :width="columns.patient.width" sortable>{{props.row.patientName}}</b-table-column>
            <b-table-column :visible="columns.officeCode.checked"  field="salesOfficeCode" label="営業所コード" :width="columns.officeCode.width" centered sortable>{{props.row.salesOfficeCode}}</b-table-column>
            <b-table-column :visible="columns.officeName.checked"  field="salesOfficeCode" label="営業所名" :width="columns.officeName.width" sortable>{{props.row.salesOfficeCode | officeFilter(salesOfficeMaster)}}</b-table-column>
            <b-table-column :visible="columns.salesStaff.checked"  field="salesStaffName" label="営業担当者名" :width="columns.salesStaff.width" sortable>{{props.row.salesStaffName}}</b-table-column>
            <b-table-column :visible="columns.ahi.checked"  field="ahi" label="AHI" :width="columns.ahi.width" sortable>
              {{props.row.ahi}}
            </b-table-column>
            <b-table-column :visible="columns.cvhri.checked" field="cvhri" label="CVHRI (最大値)" :width="columns.cvhri.width" sortable>
              {{ props.row.cvhri !== -1 ? props.row.cvhri : '算出不可' }}
            </b-table-column>
            <b-table-column :visible="columns.quickOrder.checked"  field="quickOrder" label="クイックオーダー" :width="columns.quickOrder.width" sortable><b-icon v-if="props.row.quickOrder " icon="check-bold" /></b-table-column>
            <b-table-column :visible="columns.status.checked"  field="status" label="状態" :width="columns.status.width" centered sortable>
              <span :class="getTabClass4InternalStatus(props.row.status)">
                {{getStatus(props.row.status)}}
              </span>
            </b-table-column>
            <b-table-column :visible="columns.progress.checked"  field="progress" label="進捗状況" :width="columns.progress.width" centered sortable>
              <span :class="getTabClass4RequestStatus(props.row.status)">
                {{props.row.progress}}
              </span>
            </b-table-column>
            <b-table-column :visible="columns.completionDate.checked"  field="completionDate" label="完了日" :width="columns.completionDate.width" centered sortable>{{ props.row.completionDate }}</b-table-column>
            <b-table-column :visible="columns.hstRequestFlag.checked"  field="hstRequestFlag" label="HST同梱の有無" :width="columns.hstRequestFlag.width" sortable><span v-if="props.row.hstRequestFlag == 1">有</span><span v-if="props.row.hstRequestFlag == 2">無</span></b-table-column>
            <b-table-column :visible="columns.snoreSensor.checked"  field="snoreSensor" label="いびきセンサー" :width="columns.snoreSensor.width" sortable>{{props.row.snoreSensor | snoreSensorFilter()}}</b-table-column>
            <b-table-column :visible="columns.requestDLFlag.checked"  field="requestDLFlag" label="DL(外部)" :width="columns.requestDLFlag.width" centered sortable><b-icon v-if="props.row.requestDLFlag" icon="check-bold" /></b-table-column>
            <b-table-column :visible="columns.staffDLFlag.checked"  field="staffDLFlag" label="DL(内部)" :width="columns.requestDLFlag.width" centered sortable><b-icon v-if="props.row.staffDLFlag" icon="check-bold" /></b-table-column>
            <b-table-column :visible="columns.inquiry.checked"  field="mailto" label="問い合わせ" :width="columns.inquiry.width" centered><a :href="props.row.mailto"><b-icon icon="email-outline" /></a></b-table-column>
          </template>
        </b-table>
      </div>
      <div class="result-area" v-if="dataBlank && data.length == 0">
        <div class="result-count">件数：{{data.length}}件</div>
      </div>
    </div>
  </div>
</template>

<script>
import {requestStatus} from "@/components/mock/base/const.js";
import {atLaunchHidden} from "@/components/mock/base/const.js";

const CORPORATE_KIND_LABEL = '企業検診'
const ALLOWED_CHOICES_TYPES = new Set(['1', '2', '3', '6', '14'])
const isCorporateKindLabel = (label) =>
  typeof label === 'string' && label.indexOf(CORPORATE_KIND_LABEL) !== -1
const buildKindLabelSet = (kindList) => {
  const labels = new Set()
  if (!Array.isArray(kindList)) {
    return labels
  }
  kindList.forEach((item) => {
    const label = item && item.label
    if (!label) {
      return
    }
    labels.add(label)
    if (isCorporateKindLabel(label)) {
      labels.add(CORPORATE_KIND_LABEL)
    }
  })
  return labels
}
const shouldFilterByLabel3 = (type) => String(type || '') === '2'
const passesLabel3Filter = (entry, allowedLabels, fallbackLabel) => {
  if (!entry || !entry.label3) {
    return false
  }
  if (!allowedLabels || allowedLabels.size === 0) {
    return true
  }
  if (allowedLabels.has(entry.label3)) {
    return true
  }
  return fallbackLabel ? entry.label3 === fallbackLabel : false
}
const getChoicesTypeOrder = (value) => {
  const num = Number(value)
  return Number.isNaN(num) ? Number.MAX_SAFE_INTEGER : num
}
const sortInstrumentOptions = (options) =>
  options.sort((a, b) => {
    const typeDiff =
      getChoicesTypeOrder(a.choicesType) - getChoicesTypeOrder(b.choicesType)
    if (typeDiff !== 0) {
      return typeDiff
    }
  })

export default {
  name: "RequestSearch",
  methods: {
    async prepareInstrumentKindOptions () {
      if (!sessionStorage.getItem('choiceMaster')) {
        await this.getChoiceMaster()
      }
      let options = this.buildInstrumentOptionsFromChoiceMaster()
      if (!options.length) {
        options = this.buildInstrumentOptionsFromKindMaster()
      }
      this.instrumentKindOptions = options
      this.ensureInstrumentKindInCurrentFilter()
    },
    buildInstrumentOptionsFromChoiceMaster () {
      const raw = sessionStorage.getItem('choiceMaster')
      if (!raw) {
        return []
      }
      let choiceMaster = []
      try {
        choiceMaster = JSON.parse(raw)
      } catch (error) {
        console.error(error)
        return []
      }
      const kindLabels = buildKindLabelSet(this.kindList)
      const restrictByKindLabel = kindLabels.size > 0
      const map = new Map()
      for (const group of choiceMaster) {
        if (!group || !group.choicesList) {
          continue
        }
        const type = String(group.choicesType || '')
        if (!type || !ALLOWED_CHOICES_TYPES.has(type)) {
          continue
        }
        for (const choice of group.choicesList) {
          if (choice && choice.deleteFlag) {
            continue
          }
          if (!choice || !choice.label1 || (!choice.label2 && type !== '6')) {
            continue
          }
          const kindLabel = type === '6' ? CORPORATE_KIND_LABEL : choice.label2
          if (!kindLabel) {
            continue
          }
          if (restrictByKindLabel && !kindLabels.has(kindLabel)) {
            continue
          }
          if (shouldFilterByLabel3(type) && !passesLabel3Filter(choice, kindLabels, kindLabel)) {
            continue
          }
          if (!map.has(choice.label1)) {
            map.set(choice.label1, {
              label: choice.label1,
              value: choice.label1,
              kindLabel,
              choicesType: type
            })
          }
        }
      }
      return sortInstrumentOptions(Array.from(map.values()))
    },
    buildInstrumentOptionsFromKindMaster () {
      const raw = sessionStorage.getItem('kindMaster')
      if (!raw) {
        return []
      }
      let kindMaster = []
      try {
        kindMaster = JSON.parse(raw)
      } catch (error) {
        console.error(error)
        return []
      }
      const kindLabels = buildKindLabelSet(this.kindList)
      const restrictByKindLabel = kindLabels.size > 0
      const map = new Map()
      for (const item of kindMaster) {
        if (!item) {
          continue
        }
        const type = String(item.choicesType || '')
        if (!type || !ALLOWED_CHOICES_TYPES.has(type)) {
          continue
        }
        if (!item.label1 || (!item.label2 && type !== '6')) {
          continue
        }
        const kindLabel = type === '6' ? CORPORATE_KIND_LABEL : item.label2
        if (!kindLabel) {
          continue
        }
        if (restrictByKindLabel && !kindLabels.has(kindLabel)) {
          continue
        }
        if (shouldFilterByLabel3(type) && !passesLabel3Filter(item, kindLabels, kindLabel)) {
          continue
        }
        if (!map.has(item.label1)) {
          map.set(item.label1, {
            label: item.label1,
            value: item.label1,
            kindLabel,
            choicesType: type
          })
        }
      }
      return sortInstrumentOptions(Array.from(map.values()))
    },
    ensureInstrumentKindInCurrentFilter () {
      const options = this.filteredInstrumentKindOptions
      if (!options.length) {
        this.searchConditions.instrumentKind = ''
        return
      }
      const exists = options.some(
        (option) => option.value === this.searchConditions.instrumentKind
      )
      if (!exists) {
        this.searchConditions.instrumentKind = ''
      }
    },
    doSearch: function() {
      let isSearchParam = false
      let keys = Object.keys(this.searchConditions)
      for(let i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]] && this.searchConditions[keys[i]] !="[]"){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      // Web Api Call
      var _this = this;
      this.apiCall(
        function (client) {
          let conditionStatus = JSON.parse(_this.searchConditions.status);
          let conditionProgress = JSON.parse(_this.searchConditions.progress);
          var obj = {
            receiptNumber: _this.searchConditions.receiptNumber,
            kind: JSON.parse(_this.searchConditions.kind),
            instrumentKind: _this.searchConditions.instrumentKind,
            demo: _this.searchConditions.demoFlag,
            status: conditionStatus,
            progress: conditionProgress,
            client: _this.searchConditions.client,
            hospital: _this.searchConditions.hospital,
            patientName: _this.searchConditions.patientName,
            block: _this.searchConditions.block,
            branchOfficeCode: _this.searchConditions.branchOfficeCode,
            salesOfficeCode: _this.searchConditions.salesOfficeCode,
            salesStaffName: _this.searchConditions.salesStaffName,
            applicationDateStart: _this.searchConditions.applicationDateStart,
            applicationDateEnd: _this.searchConditions.applicationDateEnd,
            completionDateStart: _this.searchConditions.completionDateStart,
            completionDateEnd: _this.searchConditions.completionDateEnd,
            judgementFlag: _this.searchConditions.judgementFlag,
            requestDLFlag: _this.searchConditions.requestDLFlag,
            staffDLFlag: _this.searchConditions.staffDLFlag,
            serial: _this.searchConditions.serial,
            hstRequestFlag: _this.searchConditions.hstRequestFlag,
            depositMachineFlag: _this.searchConditions.depositMachineFlag,
            snoreSensor: _this.searchConditions.snoreSensor,
            quickOrderFlag: _this.searchConditions.quickOrderFlag,
            ahiFrom: _this.searchConditions.ahiFrom,
            ahiTo: _this.searchConditions.ahiTo,
            cvhriFrom: _this.searchConditions.cvhriFrom,
            cvhriTo: _this.searchConditions.cvhriTo,
            cvhriFlag: _this.searchConditions.cvhriFlag
          }
          console.log(obj)
          return client.apis.internalRequestSearch.getRequestListPOST({
            body: obj
          })
        },
        function (result) {
          const instrumentFilter =
            _this.searchConditions && _this.searchConditions.instrumentKind
              ? String(_this.searchConditions.instrumentKind).trim()
              : ''
          let rows = Array.isArray(result.obj) ? result.obj : []
          if (instrumentFilter) {
            rows = rows.filter(item => {
              if (!item) {
                return false
              }
              const rawValue = item.instrumentKind !== undefined && item.instrumentKind !== null
                ? item.instrumentKind
                : item.kindLabel
              const normalized = rawValue === undefined || rawValue === null
                ? ''
                : String(rawValue).trim()
              return normalized === instrumentFilter
            })
          }

          // ===== AHI 範囲フィルタ =====
          const ahiFrom = _this.toNullableNumber(_this.searchConditions.ahiFrom)
          const ahiTo = _this.toNullableNumber(_this.searchConditions.ahiTo)

          if (ahiFrom !== null || ahiTo !== null) {
            rows = rows.filter(row => {
              const ahi = _this.getComparableMetricValue(row, 'ahi')
              if (ahi === null) return false

              if (ahiFrom !== null && ahi < ahiFrom) return false
              if (ahiTo !== null && ahi > ahiTo) return false

              return true
            })
          }

          // ===== CVHRI 範囲フィルタ =====
          const cvhriFrom = _this.toNullableNumber(_this.searchConditions.cvhriFrom)
          const cvhriTo = _this.toNullableNumber(_this.searchConditions.cvhriTo)
          const cvhriNotCalculable = _this.searchConditions.cvhriFlag === 1

          if (cvhriNotCalculable) {
            rows = rows.filter(row => _this.toNullableNumber(row && row.cvhri) === -1)
          } else if (cvhriFrom !== null || cvhriTo !== null) {
            rows = rows.filter(row => {
              const cvhri = _this.getComparableMetricValue(row, 'cvhri')
              if (cvhri === null) return false

              if (cvhriFrom !== null && cvhri < cvhriFrom) return false
              if (cvhriTo !== null && cvhri > cvhriTo) return false

              return true
            })
          }

          _this.data = rows;
          if(_this.data && _this.data.length > 0) {
            var subject = encodeURI("【問合せ】 <ここに件名を記載してください> Philips Care Portal")
            for(var item of _this.data) {
              var body = encodeURI(
                "\n"
                + "【受付番号】" + item.receiptNumber +"\n"
                + "【依頼元】" + _this.escapeStringForMailTo(item.client) +"\n"
                + "【医療機関】" + _this.escapeStringForMailTo(item.hospital) +"\n"
                + "【検査種別】" + _this.getKindGroupLabel(item.kind) +"\n"
                + "\n"
                + "【お問い合わせ内容】\n"
                + "\n"
                + "<ここにお問い合わせ内容を記載してください。>\n"
              );
              if(item.ccAddressList.length > 0){
                item.mailto = "mailto:" + item.clientlMailAddress + "?cc=" + item.ccAddressList.join(';') + "&subject=" + subject + "&body=" + body;
              } else {
                item.mailto = "mailto:" + item.clientlMailAddress + "?subject=" + subject + "&body=" + body;
              }
            }
            _this.$nextTick(() => {
              _this.chengeTableWidth(_this.tableWidth);
            })
          }
          _this.dataBlank = true;
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    changeCheckBox: function(checkboxModel) {
      var width = checkboxModel.width;
      var tableElement = this.getTableElement();
      var newWidth = 0;
      if (checkboxModel.checked) {
        newWidth = tableElement.clientWidth + width;
      } else {
        newWidth = tableElement.clientWidth - width;
      }
      this.chengeTableWidth(newWidth);

      this.setColumnSelection([checkboxModel]);
    },
    getTableElement: function(){
      var parentElement = document.getElementById(
        "requestSearchTable"
      );
      return parentElement.getElementsByTagName("table")[0];      
    },
    changeAllCheckBox: function() {
      if(this.isAllChecked){
        this.tableWidth = 0
        Object.values(this.columns).forEach(column => {
          this.tableWidth += column.width;
        });
        this.chengeTableWidth(this.tableWidth);
      } else {
        this.chengeTableWidth(0);
      }
      Object.values(this.columns).map(clumn => clumn.checked = this.isAllChecked)

      
      // 一括送信用に配列を作成
      const columnSelections = Object.values(this.columns).map(column => ({
        columnId: column.columnId,
        checked: column.checked,
        width: column.width // 必要に応じて width も含める
      }));

      // 一括送信
      this.setColumnSelection(columnSelections);
    },
    chengeTableWidth: function(width){
      var tableElement = this.getTableElement();
      tableElement.style.width = width + "px";
    },
    clipboardCopy: function(elementId) {
      console.log(elementId);
      var btable = document.getElementById(elementId);
      var tableWrapper = btable.getElementsByClassName("table-wrapper")[0];
      var table = tableWrapper.getElementsByTagName("table")[0];
      var tbody = table.getElementsByTagName("tbody")[0];
      var tr = tbody.getElementsByTagName("tr")
      var records = []
      for (let i = 0; i < tr.length; i++) {
        records.push(tr[i].innerText)
      }
      navigator.clipboard
        .writeText(records.join("\n"))
        .then(() => {
          this.showMessage("クリップボードにコピーしました。");
        })
        .catch(err => {
          this.showMessage("コピーに失敗しました");
          console.log(err);
        });
    },
    getColumnSelection: async function() {
      const _this = this;
      // Web API 呼び出し
      await this.apiCall(
        function(client) {
          const obj = {
            screenName: _this.screenName
          };
          return client.apis.apiCommon.getColumnSelectionPOST({
            body: obj
          });
        },
        function(result) {
          // 結果を反映
          const response = result.body;

          // screenId をセット
          _this.screenId = response.screenId;

          // columns を反映
          _this.serverColumns = response.columns;

          _this.serverColumns.forEach(col => {
            _this.columns[col.columnName].checked = col.displayFlag === null ? _this.columns[col.columnName].checked : col.displayFlag
            _this.columns[col.columnName].columnId = col.columnId
          });

          // 列選択の幅の設定
          _this.tableWidth = 0
          Object.values(_this.columns).forEach(column => {
            if (column.checked) _this.tableWidth += column.width;
          });
        },
        function() {
          // 列選択の幅の設定
          _this.tableWidth = 0
          Object.values(_this.columns).forEach(column => {
            if (column.checked) _this.tableWidth += column.width;
          });
          _this.showErrorMessage( "列表示状態の取得に失敗しました。<br>検索結果の列表示が初期状態となります。")
        }
      );
    },
    toNullableNumber: function(value) {
      if (value == null) return null

      const normalizedValue = typeof value === 'string'
        ? value.trim()
        : value

      if (normalizedValue === '') return null

      const num = Number(normalizedValue)
      return Number.isFinite(num) ? num : null
    },
    getComparableMetricValue: function(row, field) {
      if (!row || !this.completedStatus.includes(row.status)) return null

      const value = this.toNullableNumber(row[field])
      if (field === 'cvhri' && value === -1) return null

      return value
    },
    setColumnSelection: function(checkboxModels) {
      const _this = this;
      const columnSelections = checkboxModels.map(model => ({
        screenId: _this.screenId,
        columnId: model.columnId,
        displayFlag: model.checked
      }));

      // Web API 呼び出し
      _this.apiCall(
        function(client) {
          return client.apis.apiCommon.setColumnSelectionPOST({
            body: columnSelections // 複数データをまとめて送信
          });
        },
        function(result) {
          console.log(result);
        },
        function() {
          _this.showErrorMessage( "列選択状態の保存に失敗しました。<br>画面更新後に再度ご実施ください")
        }
      );
    },
    customSort(items, field, isAscending) {
      if (field === "ahi" || field === "cvhri") {
        return [...items].sort((a, b) => {
          const aVal = this.getComparableMetricValue(a, field);
          const bVal = this.getComparableMetricValue(b, field);

          if (aVal === null && bVal === null) return 0;
          if (aVal === null) return 1;
          if (bVal === null) return -1;

          return isAscending ? aVal - bVal : bVal - aVal;
        });
      }

      const sorted = [...items].sort((a, b) => {

        // === AHI専用 数値ソート ===
        if (field === "ahi") {
          const aVal =
            a.ahi === "" || a.ahi === null || a.ahi === undefined
              ? null
              : Number(a.ahi);
          const bVal =
            b.ahi === "" || b.ahi === null || b.ahi === undefined
              ? null
              : Number(b.ahi);

          // 未算出（空）は常に末尾
          if (aVal === null && bVal === null) return 0;
          if (aVal === null) return 1;
          if (bVal === null) return -1;

          return aVal - bVal;
        }

        // 既存カラム（受付番号・依頼日など）は今まで通り
        if (a[field] == null && b[field] == null) return 0;
        if (a[field] == null) return 1;
        if (b[field] == null) return -1;

        if (a[field] > b[field]) return 1;
        if (a[field] < b[field]) return -1;
        return 0;
      });

      return isAscending ? sorted : sorted.reverse();
    }
  },
  data() {
    var columns = {
        receiptNumber: { checked: true, width: 100 },
        applicationDate: { checked: true, width: 100 },
        kind: { checked: false, width: 230 },
        instrumentKind: { checked: true, width: 180 },
        client: { checked: false, width: 300 },
        hospital: { checked: true, width: 300 },
        patient: { checked: true, width: 150 },
        officeCode: { checked: false, width: 120 },
        officeName: { checked: false, width: 160 },
        salesStaff: { checked: false, width: 150 },
        ahi: { checked: true, width: 100 },
        cvhri: { checked: true, width: 70 },
        quickOrder: { checked: true, width: 120 },
        status: { checked: true, width: 150 },
        progress: { checked: true, width: 150 },
        completionDate: { checked: true, width: 100 },
        hstRequestFlag: { checked: false, width: 100 },
        snoreSensor: { checked: false, width: 100 },
        requestDLFlag: { checked: false, width: 100 },
        staffDLFlag: { checked: false, width: 100 },
        inquiry: { checked: true, width: 100 },
        hstRequestFlag: { checked: false, width: 120 },
        cvhri: { checked: true, width: 70 },
        snoreSensor: { checked: false, width: 120 },
        ahi: { checked: true, width: 100 },
        quickOrder: { checked: true, width: 120 }
    }
    
    var completedStatus = [
      requestStatus.completion,
      requestStatus.salesAppropriation,
      requestStatus.completionAppropriation
    ]
    // var tableWidth = 0;
    // Object.values(columns).map(clumn => {
    //   if(clumn.checked) tableWidth += clumn.width
    // })
    let salesOfficeMaster = this.getSalesOfficeMaster();
    let branchOfficeMaster = this.getBranchOfficeMaster();
    let blockMaster = this.getBlockMaster();
    let kindGroupMaster = this.getKindGroup();
    let statusList = this.getStatusList();
    console.clear()
    console.log("og-----")
    console.log(statusList)
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    //川越受付中・判定依頼中・売上計上中を削除する。
    let index = statusList.findIndex( function(item){
      return item.code.includes(requestStatus.kawagoeAcceptance)
    });
    if(index => 0){
      statusList.splice(index, 1);
    }
    index = statusList.findIndex( function(item){
      return item.code.includes(requestStatus.jugdmentRequest)
    });
    if(index => 0){
      statusList.splice(index, 1);
    }
    index = statusList.findIndex( function(item){
      return item.code.includes(requestStatus.salesAppropriation)
    });
    if(index => 0){
      statusList.splice(index, 1);
    }
    let progressList = this.getProgressList();
    let preSearchConditions = this.$route.params["searchConditions"];
    let taskSearchConditions = this.$route.params["taskSearchConditions"];
    let searchConditions = {
      receiptNumber:"",
      kind:"[]",
      instrumentKind: "",
      demoFlag: 0,
      hstRequestFlag: 0,
      depositMachineFlag: 0,
      status:"[]",
      progress:"[]",
      client:"",
      hospital:"",
      patientName: "",
      block:"",
      branchOfficeCode: "",
      salesOfficeCode: "",
      salesStaffName: "",
      applicationDateStart:"",
      applicationDateEnd:"",
      completionDateStart:"",
      completionDateEnd:"",
      judgementFlag:"",
      requestDLFlag:"",
      staffDLFlag:"",
      serial:"",
      snoreSensor:"",
      quickOrder: '',
      ahiFrom: "",
      ahiTo: "",
      cvhriFrom: "",
      cvhriTo: "",
      cvhriFlag: 0
    }
    return {
      salesOfficeMaster,
      branchOfficeMaster,
      blockMaster,
      kindGroupMaster,
      statusList,
      progressList,
      preSearchConditions,
      taskSearchConditions,
      searchConditions,
      userInfo,
      instrumentKindOptions: [],
      data: [],
      isOpen: false,
      isAllChecked: false,
      columns: columns,
      completedStatus: completedStatus,
      tableWidth : 0,
      atLaunchHidden: atLaunchHidden,
      dataBlank: false,
      screenName: "requestSearch",
      screenId: null,
      serverColumns: null,
    };
  },
  computed: {
    filteredInstrumentKindOptions () {
      if (!this.selectedKindLabel) {
        return this.instrumentKindOptions
      }
      const isCorporateSelection = isCorporateKindLabel(this.selectedKindLabel)
      return this.instrumentKindOptions.filter((option) => {
        if (isCorporateSelection) {
          return option.kindLabel === CORPORATE_KIND_LABEL
        }
        return option.kindLabel === this.selectedKindLabel
      })
    },
    selectedKindLabel() {
      if (!this.searchConditions || !this.kindGroupMaster) {
        return "";
      }
      const selected = this.kindGroupMaster.find(
        (item) => item.value === this.searchConditions.kind
      );
      return selected ? selected.label : "";
    }
  },
  filters: {
    officeFilter(value,officeList){
      var target = officeList.find(val => val.code == value)
      if(target){
        return target.name
      }
      return ""
    },  
    snoreSensorFilter(value){
      if (value == "1") {
        return "無"
      } else if (value == "2") {
        return "有"
      } else {
        return "-"
      }
    },
  },
  watch: {
    "searchConditions.kind": function () {
      this.ensureInstrumentKindInCurrentFilter();
    },
    instrumentKindOptions: function () {
      this.ensureInstrumentKindInCurrentFilter();
    }
  },
  components: {},
  mounted: async function() {
    await this.prepareInstrumentKindOptions();
    await this.getColumnSelection();
    if(this.preSearchConditions){
      this.searchConditions = this.preSearchConditions;
      this.doSearch();
    } else if (this.taskSearchConditions) {
      for (const key in this.taskSearchConditions) {
        if(key === "kind"){
          const value = (this.kindGroupMaster.find(item => item.label == this.taskSearchConditions[key]) || {}).value || null;
          this.searchConditions[key] = value;
        } else if(key === "status"){
          this.searchConditions[key]="[" + this.taskSearchConditions[key] + "]"
        } else if(key === "salesStaffName"){
          this.searchConditions[key] = this.userInfo.lastName + " " + this.userInfo.firstName
        } else if (Object.prototype.hasOwnProperty.call(this.searchConditions, key)) {
          this.searchConditions[key] = this.taskSearchConditions[key];
        }
      }
      this.doSearch();
    }
    
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
.tag {
  width: 100px;
}
.selectColumn {
  width: 800px;
  position: absolute;
  background-color: white;
  z-index: 25;
}

</style>



// WEBPACK FOOTER //
// src/components/mock/philips/search/RequestSearch.vue